import styled, { css } from "styled-components";
import React from "react";

import breakpoints from "../../../styles/breakpoints";
import { header } from "../../../styles/variables";

import SideTray from ".";

const StyledSideTray = styled((props) => <SideTray {...props} />).attrs(() => ({
  displayName: "StyledSideTray",
}))`
  ${breakpoints.smUp} {
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: 0;
      `}
  }
  ${breakpoints.mdDown} {
    top: 0;
  }
  ${breakpoints.smDown} {
    ${(props) =>
      props.isInBoxAndCartTray &&
      css`
        top: ${header.mobileHeight};
      `}
  }
`;

export default StyledSideTray;
